// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__12bfx","title":"Header_title__3PipY","side":"Header_side__2j6v1"};